/**
 * Social post enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Social post status labels
export const socialPostStatusLabels = {
    draft: 'Draft',
    scheduled: 'Scheduled',
    publishing: 'Publishing',
    published: 'Published',
    partial: 'Partial',
    failed: 'Failed',
};
export const socialPostStatusValues = Object.keys(socialPostStatusLabels);
// Social post media type labels
export const socialPostMediaTypeLabels = {
    image: 'Image',
    video: 'Video',
};
export const socialPostMediaTypeValues = Object.keys(socialPostMediaTypeLabels);
// Social platform labels
export const socialPlatformLabels = {
    facebook: 'Facebook',
    instagram: 'Instagram',
};
export const socialPlatformValues = Object.keys(socialPlatformLabels);
//# sourceMappingURL=social-posts.js.map